import axios from '../axios'
import { USERACTIVITYROUTES } from 'src/router/Api'

export interface UserActivityParams {
	limit: number
	offset: number
	category?: string
	search_field?: string
	search_value?: string
}

export interface UserActivityExportParams {
	category?: string
	search_field?: string
	search_value?: string
}

export const getActiveUsers = async (params: UserActivityParams) => {
	return await axios.get(USERACTIVITYROUTES.name, {
		params,
	})
}

// UD-559: window dates, the number on every card, total users and the no-open count in one call.
export const getActiveUsersOverview = async () => {
	return await axios.get(USERACTIVITYROUTES.overview)
}

// UD-559: the notes about one user from every admin (adding, editing and deleting stay on /cms-note).
export const getActiveUserNotes = async (userId: string, limit = 100) => {
	return await axios.get(USERACTIVITYROUTES.notes(userId), {
		params: { limit, offset: 0 },
	})
}

// UD-559: the selected card and search as a CSV, every page. The server streams it in chunks.
export const exportActiveUsersCsv = async (params: UserActivityExportParams) => {
	return await axios.get<Blob>(USERACTIVITYROUTES.export, {
		params,
		responseType: 'blob',
		// A 37,000 row card takes longer than a normal call; the server keeps sending while it works.
		timeout: 0,
	})
}

export const sendActiveUserEmail = async (
	userId: string,
	payload: {
		subject: string
		body: string
	},
) => {
	return await axios.post(USERACTIVITYROUTES.sendEmail(userId), payload)
}
